export const SliderData = [
    {
        image: "/img/beats.jpg",
        title :"Beats By Dre",
        desc : `A mobile responsive shopping web app for BeatsByDre Headphones, built with React js,
                 adaptable to all devices and with animation interactions`,
        link:  "https://beatsbydreclone.herokuapp.com/",
    },
   
    {
        image: "/img/dashboard.png",
        title :"Admin Dashboard",
        desc : `An admin dashboard template built with Reactjs, chartjs, table, styled-components.
                it is built with the use of large screen in mind`,
        link:  "https://ojidashboard.herokuapp.com/",
    },
    {
        image: "/img/netflix.jpg",
        title :"Netflix Clone",
        desc : `A Netflix clone mini project, built with reactjs, nodejs, mongodb.It's still a work
                in progress though.`,
        link: "https://ojidemo.herokuapp.com/",
    },
]